/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Events_Selected_LowercaseInputs */



/**
* | output |
* | --- |
* | "No events selected to convert to lowercase." |
*
* @param {No_Events_Selected_LowercaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_events_selected_lowercase = /** @type {((inputs?: No_Events_Selected_LowercaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Events_Selected_LowercaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun événement sélectionné pour la conversion en minuscules.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine Ereignisse ausgewählt, die in Kleinbuchstaben umgewandelt werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento selezionato da convertire in minuscolo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для преобразования в нижний регистр не выбрано ни одного события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay eventos seleccionados para convertir a minúsculas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有选择要转换为小写的事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("小文字に変換するイベントが選択されていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लोअरकेस में बदलने के लिए कोई इवेंट चयनित नहीं हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento selecionado para conversão para minúsculas.")
	return /** @type {LocalizedString} */ ("No events selected to convert to lowercase.")
});